import React from 'react';

import {useSelector} from 'react-redux';

import {NextStepLink} from './NextStepLink';
import {StepLane} from './StepLane';
import {StepLaneDiff} from './StepLaneDiff';

import {AnyStepType, LaneSerializedType} from 'sweet-types';

interface Props<S extends AnyStepType> {
  step: S;
  steps: Array<S>;
  stepLaneId?: string | null;
  laneDiff?: {new: string | null; old: string | null};
}

export function StepFooter<S extends AnyStepType>({
  step,
  steps,
  stepLaneId,
  laneDiff,
}: Props<S>) {
  const lane: LaneSerializedType | null = useSelector((state) =>
    stepLaneId != null ? state.lanes.byId[stepLaneId] : null
  );

  return (
    <div
      className="d-flex flex-wrap justify-content-between"
      style={{lineHeight: 1}}
    >
      <div className="mb-2">
        {laneDiff != null ? (
          <StepLaneDiff laneDiff={laneDiff} />
        ) : lane != null ? (
          <StepLane lane={lane} />
        ) : null}
      </div>

      <div className="mb-2">
        {!step.type ||
        step.type === 'content' ||
        step.type === 'processprocedure' ? (
          <NextStepLink
            next={'next' in step ? step.next : undefined}
            steps={steps}
          />
        ) : null}
      </div>
    </div>
  );
}
